import CustomButton from "../../components/Button";
import AddOrderIcon from "../../assets/Order/AddOrder.svg";
import BlukOrderIcon from "../../assets/Order/BlukOrderIcon.svg";
import SyncIcon from "../../assets/Order/SyncIcon.svg";
import { OrderStatus } from "./OrderStatus";
import FilterIcon from "../../assets/Order/FilterIcon.svg";
import Delivery_Icon from "../../assets/Delivery Icon.svg";
import DeliveryGIF from "../../assets/OrderCard/Gif.png";
import { CustomTable } from "../../components/Table";
import { useCallback, useEffect, useRef, useState } from "react";
import {
  columnHelperForNewOrder,
  ColumnHelperForBookedAndReadyToPicked,
  columnHelpersForRest,
} from "./ColumnHelpers";
import "./common/FilterScreen/OrderInput.css";
import { useMediaQuery } from "react-responsive";
import { ResponsiveState } from "../../utils/responsiveState";
import { POST } from "../../utils/webService";
import {
  CANCEL_MULTIPLE_WAYBILLS,
  CANCEL_TEMP_SELLER_ORDER,
  GET_SELLER_ORDER,
  GET_STATUS_COUNT,
  POST_SYNC_ORDER,
  FETCH_LABELS_REPORT_DOWNLOAD,
  FETCH_MULTI_TAX_REPORT_DOWNLOAD,
  GET_ORDER_ERRORS,
  RECHARGE_STATUS,
  PAYMENT_ERRORS,
  DUPLICATE_ORDER,
  COMPANY_NAME,
  FETCH_MANIFEST_DATA,
  GET_COUNT_AMAZON_ORDER,
  GET_COUNT_SHOPIFY_FULFILLMENT,
  POST_TRIGGER_SHOPIFY_FULFILLMENT,
} from "../../utils/ApiUrls";
import OrderCard from "./OrderCard";
import "../../styles/index.css";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Breadcrum } from "../../components/Layout/breadcrum";
import CenterModal from "../../components/CustomModal/customCenterModal";
import BulkUpload from "./BulkUpload/BulkUpload";
import { useSelector, useDispatch } from "react-redux";
import AccessDenied from "../../components/AccessDenied";
import OnePagination from "../../components/OnePagination/OnePagination";
import DeleteModal from "../../components/CustomModal/DeleteModal";
import { DeleteModal as DeleteModalDraftOrder } from "../../components/DeleteModal";
import CustomTableAccordian from "../../components/CustomAccordian/CustomTableAccordian";
import ReverseCustomAccordian from "./Reverse/index";
import ReverseSummary from "./Reverse/summary";
import { checkPageAuthorized } from "../../redux/reducers/role";
import CustomRightModal from "../../components/CustomModal/customRightModal";
import orderCardImg from "../../assets/OrderCard/Gif.gif";
import CloseIcon from "../../assets/CloseIcon.svg";
import {
  capitalizeFirstLetter,
  getLocalStorage,
  getQueryJson,
  removeLocalStorage,
  tokenKey,
} from "../../utils/utility";
import "../../styles/hideScroll.css";
import Errors from "./Errors";
import ErrorModal from "./ErrorModal";
import PartnerJumperModal from "./PartnerJumberModal";
import DatePicker from "react-datepicker";
import RightSideModal from "../../components/CustomModal/customRightModal";
import { SearchBox } from "../../components/SearchBox";
import FilterScreen from "./common/FilterScreen/filterScreen";
import { Spinner } from "../../components/Spinner";
import "../../styles/progressBar.css";
import NewTrackingContent from "./newTrackingContent";
import OneButton from "../../components/Button/OneButton";
import DoneIcon from "../../assets/Done .svg";
import DateButton from "../../components/Button/DateButton";
import { DuplicateModel } from "../../components/Duplicate";
import ShopifyIcon from "../../assets/Catalogue/shopifyLg.svg";
import WoocommerceIcon from "../../assets/Catalogue/WooCommerceLg.svg";
import UnicommerceIcon from "../../assets/Catalogue/unicommerce fn.svg";
import { timerObject } from "../../redux/reducers/syncChannel";
import WhatsappIcon from "../../assets/whatsappIcon.svg";
import DeltaOnBlaze from "./deltaOnBlaze";
import sessionManager from "../../utils/sessionManager";
import { decryptData } from "../../utils/Helper/Filter";
import { buildOrderListApiPayload } from "./buildOrderListPayload";
import DraftOrderProductModal from "./DraftOrderProductModal";

let allOrdersCount: any;
const ordersArr = [
  {
    count: 23,
    text: "Today's delivery",
    img: "CreateOrderIcon",
  },
  {
    count: 34,
    text: "Today's delivery",
    img: "ShippedIcon",
  },
  {
    count: 12,
    text: "Today's delivery",
    img: "InTransitIcon",
  },
  {
    count: 17,
    text: "Today's delivery",
    img: "InTransitIcon",
  },
];

const tabs = [
  {
    statusName: "Draft",
    value: "DRAFT",
    orderNumber: 0,
  },
  {
    statusName: "Booked",
    value: "BOOKED",
    orderNumber: 0,
  },
  {
    statusName: "Picked Up",
    value: "PICKED UP",
    orderNumber: 0,
  },
  {
    statusName: "In Transit",
    value: "IN TRANSIT",
    orderNumber: 0,
  },
  {
    statusName: "Out For Delivery",
    value: "OUT OF DELIVERY",
    orderNumber: 0,
  },
  {
    statusName: "Delivered",
    value: "DELIVERED",
    orderNumber: 0,
  },
  {
    statusName: "RTO In Transit",
    value: "RTO IN TRANSIT",
    orderNumber: 0,
  },
  {
    statusName: "RTO Out For Delivery",
    value: "RTO OUT FOR DELIVERY",
    orderNumber: 0,
  },
  {
    statusName: "RTO Delivered",
    value: "RTO DELIVERED",
    orderNumber: 0,
  },
  {
    statusName: "RTO Exception",
    value: "RTO EXCEPTION",
    orderNumber: 0,
  },
  {
    statusName: "Exception",
    value: "EXCEPTION",
    orderNumber: 0,
  },
  {
    statusName: "Cancelled",
    value: "CANCELLED",
    orderNumber: 0,
  },
  {
    statusName: "Lost and Damage",
    value: "LOST_AND_DAMAGE",
    orderNumber: 0,
  },
  // {
  //   statusName: "All Orders",
  //   value: "ALL",
  //   orderNumber: 0,
  // },
];

const Index = () => {
  const companyName = COMPANY_NAME;

  const getInitialTabIndex = () => {
    const queryTab = getQueryJson().activeTab?.toUpperCase();
    const index = tabs.findIndex((tab) => tab.value === queryTab);
    return index >= 0 ? index : 0;
  };

  const [globalIndex, setGlobalIndex] = useState(() => getInitialTabIndex());
  const [tabStatusId, setTabStatusId] = useState(() => getInitialTabIndex());
  const [currentTap, setCurrentTap] = useState<any>(
    () => tabs[getInitialTabIndex()]?.value || "DRAFT",
  );

  const [filterId, setFilterId]: any = useState(0);
  const [statusData, setStatusData]: any = useState(tabs);
  const [orders, setOrders]: any = useState([]);
  const [allOrders, setAllOrders]: any = useState([]);
  const [totalOrders, setTotalOrders]: any = useState([]);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [columnHelper, setColumnhelper]: any = useState([]);
  const [totalCount, setTotalcount]: any = useState(100);
  const syncRef: any = useRef(null);
  const syncRefreshTriggeredRef = useRef(false);
  const [cancellationModal, setCancellationModal]: any = useState({
    isOpen: false,
    awbNo: "",
    orderId: "",
    orderSources: [], // Add this line
  });
  const [isChannelPartner, setIsChannelPartner] = useState(false);
  const [storeDetails, setStoreDetails] = useState([]);
  const [buyerConfirmationStatus, setBuyerConfirmationStatus]: any =
    useState("");
  const [skip, setSkip] = useState(0);
  const scrollRef: any = useRef(null);
  const [subStatus, setSubStatus] = useState("");
  const [isOrderPlaced, setIsOrderPlaced] = useState(false);
  const [deleteModalDraftOrder, setDeleteModalDraftOrder]: any = useState({
    isOpen: false,
    payload: "",
    orderSources: [],
  });
  const [partnerModalData, setPartnerModalData]: any = useState({
    isOpen: false,
    data: [],
  });
  const [duplicateOrderModalData, setDuplicateOrderModalData]: any = useState({
    isOpen: false,
    data: [],
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [infoModalContent, setInfoModalContent]: any = useState({
    isOpen: false,
    data: {},
    orderId: "",
  });
  const [productDetailsModal, setProductDetailsModal]: any = useState({
    isOpen: false,
    data: {},
  });
  const [infoReverseModalContent, setInfoReverseModalContent]: any = useState({
    isOpen: false,
    data: {},
  });
  const [bookReverseCenterModal, setBookReverseCenterModal] = useState(false);
  const [
    infoReverseSummaryModalContent,
    setInfoReverseSummaryModalContent,
  ]: any = useState({
    isOpen: false,
    data: {},
  });
  const [isSyncModalOpen, setIsSyncModalOpen]: any = useState(false);
  const [isSyncModalLoading, setIsSyncModalLoading] = useState(true);

  const channelReduxData = useSelector((state: any) => state?.channel?.channel);
  const dispatch = useDispatch();
  const isMasked = useSelector((state: any) => state?.user?.isMasked);

  const isMobileView = useMediaQuery({ maxWidth: 768 }); // Adjust the breakpoint as per your requirement
  const { isLgScreen, isXlScreen } = ResponsiveState();
  const navigate = useNavigate();
  const [isDeleted, setIsDeleted] = useState(false);
  const [selectedRowdata, setSelectedRowData] = useState([]);
  const isActive = checkPageAuthorized("View Orders");
  const [isSticky, setIsSticky] = useState(false);
  const [isFilterLoading, setIsFilterLoading] = useState<any>(false);
  const [itemsPerPage, setItemsPerPage] = useState(() => {
    if (typeof window !== "undefined") {
      return window.innerWidth >= 1024 ? 100 : 10;
    }
    return 10;
  });
  const [draftOrderCount, setDraftOrderCount] = useState({
    all: 0,
    draft: 0,
    failed: 0,
    error: 0,
  });
  const [filterModal, setFilterModal] = useState(false);
  const [filterState, setFilterState] = useState({
    name: "",
    menu: [],
    label: "",
    isCollapse: false,
  });
  const [filterPayLoad, setFilterPayLoad] = useState({
    filterArrOne: [],
    filterArrTwo: [],
  });
  const [sortByOrderId, setSortByOrderId] = useState<"" | "asc" | "desc">("");

  const [persistFilterData, setPersistFilterData]: any = useState({
    deliveryPincode: [],
    pickupPincode: [],
    sku: [],
    productName: [],
    buyerConfirmation: [],
    store: [],
  });

  const [isErrorPage, setIsErrorPage] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorData, setErrorData]: any = useState();
  const [isErrorListLoading, setIsErrorListLoading] = useState(false);
  const [errorModalData, setErrorModalData]: any = useState();
  const [dateRange, setDateRange]: any = useState([null, null]);
  const [endDate, setEndDate] = useState<any>(new Date());
  const [openRightModalForTracking, setOpenRightModalForTracking] =
    useState<any>({
      isOpen: false,
      awbNo: "",
    });
  const [openRightModalForDelta, setOpenRightModalForDelta] =
    useState<any>(false);
  const [startDate, setStartDate] = useState<any>(new Date());
  const [searchedText, setSearchedText] = useState("");
  // What the user is typing; copied to `searchedText` (which triggers the
  // API call) only after they stop typing for 500ms.
  const [searchInput, setSearchInput] = useState("");
  // Only the latest order-list / status-count request may update the screen.
  const ordersRequestIdRef = useRef(0);
  const ordersAbortRef = useRef<AbortController | null>(null);
  const statusCountRequestIdRef = useRef(0);
  const statusCountAbortRef = useRef<AbortController | null>(null);

  useEffect(() => {
    const timer = setTimeout(() => setSearchedText(searchInput.trim()), 500);
    return () => clearTimeout(timer);
  }, [searchInput]);

  useEffect(() => {
    return () => {
      ordersAbortRef.current?.abort();
      statusCountAbortRef.current?.abort();
    };
  }, []);
  const [resetFilter, setResetFilter] = useState(false);
  const [bulkActionObject, setBulkActionObject] = useState({
    pickupAddress: {
      name: "",
      mobileNo: "",
      fullAddress: "",
      pincode: "",
      landMark: "",
    },
    deliveryAddress: {
      name: "",
      mobileNo: "",
      fullAddress: "",
      pincode: "",
      landMark: "",
    },
    box: {
      name: "Box",
      length: "1",
      breadth: "1",
      height: "1",
      weight: "1",
      volumetricWeight: "0",
      appliedWeight: "1",
    },
  });
  const [isBulkCheckedBooked, setIsBulkCheckedBooked]: any = useState(false);

  const [fullfillment, setFullfillment] = useState();
  const [unFullfillment, setUnFullfillment] = useState();
  const [ShopifyFullfillment, setShopifyFullfillment] = useState();
  const [unShopifyFullfillment, setUnShopifyFullfillment] = useState();
  const [isShopifyFulfillmentLoading, setIsShopifyFulfillmentLoading] =
    useState(false);
  //  // Add ref for the abort controller
  //    const [renderingComponents, setRenderingComponents] = useState<number>(0);

  //  const fetchDataControllerRef = useRef<AbortController | null>(null);
  //  const currentTabRef = useRef<number>(renderingComponents);

  // const [isMasked, setIsMasked] = useState(false);

  // useEffect(() => {
  //   let temp = JSON.parse(localStorage.getItem("userInfo") as any);
  //   if (temp) {
  //     setIsMasked(temp?.isMaskedUser);
  //   }
  // }, []);
  let debounceTimer: any;
  let { activeTab } = getQueryJson();
  activeTab = activeTab?.toUpperCase();

  // let syncChannelTextObj: any = localStorage.getItem("userInfo");
  const { sellerInfo } = sessionManager({});
  // const isImpersonateLogin = true; // Force to true for testing

  const isImpersonateLogin = !!sellerInfo?.isImpersonateLogin;
  let syncChannelTextObj = sellerInfo;
  // syncChannelTextObj = JSON.parse(syncChannelTextObj);

  // let kycValue: any = localStorage.getItem("kycValue");

  let kycValue = sellerInfo;
  // kycValue = JSON.parse(kycValue);

  let syncTimerState = useSelector((state: any) => state?.channel?.time?.time);

  let syncChannelText = syncChannelTextObj?.nextStep?.isChannelIntegrated
    ? "Sync Channel"
    : "Add Channel";

  const setInfoModalContentFunction = async (data: any) => {
    setInfoModalContent({
      isOpen: true,
      data: data,
      orderId: "",
    });
  };

  const setInfoReverseModalFunction = async (data: any) => {
    setInfoReverseModalContent({
      isOpen: true,
      data: data,
    });
  };

  const setInfoReverseSummaryModalFunction = async (data: any) => {
    setInfoReverseSummaryModalContent({
      isOpen: true,
      data: data,
    });
  };
  const resetAllFilter = () => {
    setFilterPayLoad({
      filterArrOne: [],
      filterArrTwo: [],
    });
    setFilterModal(false);
    setFilterState({
      name: "",
      menu: [],
      label: "",
      isCollapse: false,
    });
    setPersistFilterData({
      deliveryPincode: [],
      pickupPincode: [],
      sku: [],
      productName: [],
      buyerConfirmation: [],
      store: [],
    });
    setSortByOrderId("");
    setResetFilter(true);
  };

  const getAllOrders = async () => {
    //get all orders
    const currentStatus = tabs[globalIndex]?.value || "DRAFT"; //current status of the order

    const { apiPayload } = buildOrderListApiPayload({
      skip,
      limit: itemsPerPage,
      filterPayLoad,
      startDate,
      endDate,
      searchedText,
      subStatus,
      currentStatus,
      sortByOrderId,
    });

    // Cancel the previous request and mark this one as the latest.
    ordersAbortRef.current?.abort();
    const controller = new AbortController();
    ordersAbortRef.current = controller;
    const requestId = ++ordersRequestIdRef.current;

    try {
      setIsLoading(true);
      const response = await POST(GET_SELLER_ORDER, apiPayload, {
        signal: controller.signal,
      });
      // A newer search/filter started meanwhile: ignore this old response.
      if (requestId !== ordersRequestIdRef.current) return;
      let data = response?.data;

      getStatusCount(apiPayload);
      if (data?.status) {
        let { OrderData, orderCount, draftCount, errorCount } = data?.data?.[0];
        // setSearchedText("");
        if (OrderData?.encryptedData) {
          OrderData = decryptData(OrderData?.encryptedData);
          console.log(OrderData, "ORDER DATA");
        }
        setOrders(OrderData || []);
        // setAllOrders(OrderData);
        setDraftOrderCount({
          ...draftOrderCount,
          all: draftCount + errorCount || 0,
          draft: draftCount || 0,
          error: errorCount || 0,
        });

        setTotalcount(orderCount || 0);
      }
    } catch (error) {
      if (requestId !== ordersRequestIdRef.current) return;
      setIsLoading(false);
      throw error;
    } finally {
      // Only the latest request may hide the loader.
      if (requestId === ordersRequestIdRef.current) setIsLoading(false);
    }
  };

  const isChannelSyncComplete = (elem: any) => {
    const total = elem?.TotalOrderCount || 0;
    const synced = elem?.syncedOrder || 0;

    if (total === 0) return true;

    return synced >= total || total - synced <= 5;
  };

  const refreshOrdersAfterSync = async () => {
    if (syncRefreshTriggeredRef.current) return;

    syncRefreshTriggeredRef.current = true;

    try {
      await getAllOrders();
      toast.success("Orders synced successfully", {
        className: "custom-toast-success",
      });
    } catch (error) {
      console.error("Failed to refresh orders after sync:", error);
    }
  };
  const refreshOrdersAfterSyncRef = useRef(refreshOrdersAfterSync);
  refreshOrdersAfterSyncRef.current = refreshOrdersAfterSync;

  const handleClear = () => {
    setDateRange([null, null]);
    setStartDate(null);
    setEndDate(null);
  };

  useEffect(() => {
    setSkip(0);
    setIsOrderPlaced(false);
    setSubStatus("");
  }, [globalIndex]);

  useEffect(() => {
    setItemsPerPage(isLgScreen ? 100 : 10);
    setSkip(0);
  }, [isLgScreen]);
  useEffect(() => {
    if (!isActive) return;

    const tabIndex = activeTab
      ? getIndexFromActiveTab(statusData, activeTab)
      : getInitialTabIndex();

    if (activeTab && tabIndex !== globalIndex) {
      handleTabChanges(
        tabIndex,
        true,
        searchedText,
        startDate,
        endDate,
        filterPayLoad,
        itemsPerPage,
      );
      return;
    }

    getAllOrders();
  }, [
    isActive,
    activeTab,
    globalIndex,
    itemsPerPage,
    skip,
    endDate,
    searchedText,
    resetFilter,
    subStatus,
    isOrderPlaced,
    buyerConfirmationStatus,
  ]);

  const Buttons = (className?: string) => {
    return (
      <div>
        <div className="flex flex-col sm:flex-row sm:justify-end mb-4 gap-2 sm:gap-2">
          <div className="w-full sm:w-auto">
            <DatePicker
              selectsRange={true}
              startDate={startDate}
              endDate={endDate}
              wrapperClassName="w-full sm:w-auto"
              onChange={(update: any) => {
                setDateRange(update);
                if (update[0] === null && update[1] === null) {
                  setStartDate(null);
                  setEndDate(null);
                } else {
                  setStartDate(update[0]);
                  setEndDate(update[1]);
                }
              }}
              dateFormat="dd/MM/yyyy"
              customInput={
                <DateButton
                  text="Select From & To Date" // Text for the button
                  onClick={() => {}} // onClick is managed by DatePicker
                  className="h-[36px] w-full"
                  value={
                    startDate && endDate
                      ? `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
                      : ""
                  }
                  onClear={handleClear}
                />
              }
            />
          </div>
          <div className="w-full sm:w-auto flex flex-col sm:flex-row items-stretch sm:items-center gap-2">
            <div className="w-full sm:flex-none sm:w-[250px] flex items-center rounded-md border-[#AFAFAF] border">
              <SearchBox
                className="removePaddingPlaceHolder !h-[34px] w-full border-none"
                label="Search"
                value={searchInput}
                onChange={(e: any) => {
                  setSearchInput(e.target.value);
                }}
                getFullContent={() => {
                  setSearchInput("");
                  setSearchedText("");
                }}
                customPlaceholder="Search By Order Id, AWB"
              />
            </div>

            {/* Keep Filter here only for desktop/tablet */}
            <div className="hidden sm:block">
              <button
                type="button"
                onClick={() => setFilterModal(true)}
                className="h-[36px] px-3 rounded-md flex items-center gap-1 text-[13px] font-Open font-semibold leading-5 whitespace-nowrap text-blue-600 border border-blue-200 hover:bg-blue-50 active:bg-blue-100"
              >
                <img src={FilterIcon} alt="" className="w-4 h-4" />
                <span>FILTER</span>
                {(filterPayLoad.filterArrOne.length > 0 ||
                  filterPayLoad.filterArrTwo.length > 0 ||
                  sortByOrderId) && (
                  <span className="ml-1 border border-blue-600 px-1 text-[11px] leading-4 text-center items-center flex rounded-full">
                    {filterPayLoad.filterArrOne.length +
                      filterPayLoad.filterArrTwo.length +
                      (sortByOrderId ? 1 : 0)}
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
        <div
          className={
            className
              ? className
              : `grid grid-cols-2 gap-3 mt-3 sm:mt-6 items-stretch sm:flex sm:flex-wrap sm:justify-end sm:items-center sm:gap-2 lg:mt-0 lg:flex lg:flex-wrap lg:flex-row-reverse`
          }
        >
          <div className="col-span-2 sm:col-span-auto">
            <OneButton
              text=" ADD ORDER"
              onClick={() => navigate("/orders/place-order")}
              variant="primary"
              showIcon={true}
              icon={AddOrderIcon}
              className="w-full sm:w-auto !h-[44px] !px-3 sm:!px-4 !py-2 !text-sm sm:!text-base"
            />
          </div>

          <div className="col-span-1 sm:col-span-auto">
            <OneButton
              text="Bulk Upload"
              onClick={() => navigate("/orders/add-bulk")}
              variant="secondary"
              showIcon={true}
              icon={BlukOrderIcon}
              className="w-full sm:w-auto !h-[44px] !px-3 sm:!px-4 !py-2 !text-sm sm:!text-base"
            />
          </div>
          {/* {isLgScreen && kycValue?.communicationRateCardExists ? (
            <OneButton
              text="Delivery Max"
              className="!bg-[#60D669] !border-[#60D669] !text-[#FFFFFF] !px-4 !py-2 !font-Open !font-semibold !text-[14px] !leading-5 !rounded-[4px] hover:!bg-[#27B031] hover:!shadow-cardShadow2a focus:!bg-[#60D669] focus:border focus:!border-[#27B031]"
              onClick={() => setOpenRightModalForDelta(true)}
              showIcon={true}
              icon={WhatsappIcon}
            />
          ) : (
            <></>
          )} */}

          {/* <div className="flex gap-3">
            <span className="flex flex-1 min-w-fit items-center py-[6px] rounded-md px-[10px] border-[1px] border-[#A4A4A4]   font-medium text-[#1C1C1C]">
              Amazon Fulfillment (
              {Number(unFullfillment || 0) + Number(fullfillment || 0)}/{" "}
              {Number(fullfillment || 0)})
            </span>
            <span className="flex flex-1 min-w-fit items-center py-[6px] rounded-md px-[10px] border-[1px] cursor-pointer border-[#A4A4A4]   font-medium text-[#1C1C1C]">
              Amazon unfulfillment ({unFullfillment})
            </span>
          </div> */}
          {currentTap === "BOOKED" &&
            syncChannelTextObj?.nextStep?.isShopifyApp && (
              <div className="col-span-2 sm:col-span-auto flex gap-2">
                <OneButton
                  text={
                    isShopifyFulfillmentLoading
                      ? "Triggering..."
                      : `Shopify Fulfillment (${Number(
                          unShopifyFullfillment || 0,
                        )}/${Number(ShopifyFullfillment || 0)})`
                  }
                  onClick={handleTriggerShopifyFulfillment}
                  variant="secondary"
                  disabled={isShopifyFulfillmentLoading}
                  className="w-full sm:w-auto !justify-start !font-medium !text-[#1C1C1C] !py-2 !px-3 sm:!px-[10px] !h-auto hover:bg-[#FFFFFF] !hover:shadow-none cursor-pointer !text-sm sm:!text-base"
                  textTransform="none"
                />
              </div>
            )}
          <div className="col-span-1 sm:col-span-auto flex gap-2 min-w-0">
            <OneButton
              text={`Amazon Fulfillment (${
                Number(unFullfillment || 0) + Number(fullfillment || 0)
              }/${Number(fullfillment || 0)})`}
              onClick={() => {
                /* Add your function here */
              }}
              variant="secondary"
              className="w-full sm:w-auto !h-[44px] !min-w-0 !justify-center sm:!justify-start !font-medium !text-[#1C1C1C] !py-2 !px-2 sm:!px-4 hover:bg-[#FFFFFF] !hover:shadow-none !cursor-not-allowed !text-[12px] sm:!text-base !whitespace-nowrap !overflow-hidden !text-ellipsis"
              textTransform="none"
            />
          </div>

          {currentTap === "DRAFT" && (
            <div
              ref={syncRef}
              onClick={handleSyncOrder}
              className="col-span-2 sm:col-span-auto relative overflow-hidden flex items-center justify-center gap-2 px-3 sm:px-4 h-[44px] rounded-md border border-[#A4A4A4] bg-white cursor-pointer hover:bg-[#F6F6F6] w-full sm:w-auto"
            >
              <img
                src={SyncIcon}
                alt=""
                width="16px"
                className="relative z-10 shrink-0"
              />
              <span className="relative z-10 text-[#004EFF] text-sm font-medium whitespace-nowrap sm:text-base lg:text-[#1C1C1C]">
                {syncChannelText}
              </span>
              <div className="hidden lg:block absolute top-0 right-0 z-0 transition-all duration-500 ease-in-out w-[0px] bg-[#fff] h-full rounded-md pointer-events-none"></div>
            </div>
          )}

          {/* Mobile-only Filter button (paired with Add Channel) */}
          <div className="col-span-1 sm:hidden">
            <button
              type="button"
              onClick={() => setFilterModal(true)}
              className="w-full h-[44px] px-3 rounded-md flex items-center justify-center gap-2 text-[13px] font-Open font-semibold leading-5 whitespace-nowrap text-[#1C1C1C] border border-[#A4A4A4] bg-white hover:bg-[#F6F6F6] active:bg-[#EDEDED]"
            >
              <img src={FilterIcon} alt="" className="w-4 h-4" />
              <span>FILTER</span>
              {(filterPayLoad.filterArrOne.length > 0 ||
                filterPayLoad.filterArrTwo.length > 0 ||
                sortByOrderId) && (
                <span className="ml-1 border border-[#1C1C1C] px-1 text-[11px] leading-4 text-center items-center flex rounded-full">
                  {filterPayLoad.filterArrOne.length +
                    filterPayLoad.filterArrTwo.length +
                    (sortByOrderId ? 1 : 0)}
                </span>
              )}
            </button>
          </div>

          {isModalOpen && (
            <CenterModal
              isOpen={isModalOpen}
              onRequestClose={() => setIsModalOpen(false)}
            >
              <BulkUpload
                onClick={() => {
                  setIsModalOpen(false);
                }}
              />
            </CenterModal>
          )}
        </div>
      </div>
    );
  };

  const handleTriggerShopifyFulfillment = async () => {
    if (isShopifyFulfillmentLoading) return;
    setIsShopifyFulfillmentLoading(true);
    try {
      const { data } = await POST(POST_TRIGGER_SHOPIFY_FULFILLMENT, {});
      if (data?.code === 200 || data?.success) {
        toast.success(
          data?.message || "Shopify fulfillment triggered successfully",
        );
        const { data: countData } = await POST(GET_COUNT_SHOPIFY_FULFILLMENT);
        if (countData?.code === 200 && countData?.data) {
          const temp = countData?.data;
          setShopifyFullfillment(temp?.fulfilled || 0);
          setUnShopifyFullfillment(temp?.booked || 0);
        }
      } else {
        toast.error(data?.message || "Failed to trigger Shopify fulfillment");
      }
    } catch (error: any) {
      toast.error(error?.message || "Failed to trigger Shopify fulfillment");
    } finally {
      setIsShopifyFulfillmentLoading(false);
    }
  };

  const handleSyncOrder = async () => {
    console.log(channelReduxData, "CHANNEL REDUX");
    try {
      if (syncChannelText.includes("Sync Channel")) {
        setIsSyncModalOpen(true);
        syncRefreshTriggeredRef.current = false;

        if (syncRef.current) {
          const buttonTextNode = syncRef.current.childNodes[1];
          const buttonIconNode = syncRef.current.childNodes[0];

          syncRef.current.style.backgroundColor = "#F8F8F8";

          syncRef.current.style.pointerEvents = "none";

          if (buttonIconNode) {
            buttonIconNode.classList.add("infinite-rotate");
          }

          if (buttonTextNode) {
            buttonTextNode.textContent = "Sync In Progress...";
          }
        }
      }
      let payload: any = {};

      if (startDate && endDate) {
        let startEpoch = null;
        let lastendEpoch = null;

        if (startDate instanceof Date && endDate instanceof Date) {
          startDate.setHours(0, 0, 0, 0);
          startEpoch = startDate.getTime();

          endDate.setHours(23, 59, 59, 999);
          const endEpoch = endDate.getTime();

          lastendEpoch = endEpoch;
        }

        payload.dateFilter = {
          createdAtMin: {
            $gte: startEpoch,
          },

          createdAtMax: {
            $lte: lastendEpoch,
          },
        };
      }

      const { data } = await POST(POST_SYNC_ORDER, payload);
      if (data?.success) {
        if (data?.message.includes("CHANNELPARTNER")) {
          setIsChannelPartner(true);
          setIsSyncModalLoading(false);
          toast.success("Channel Partner Exists", {
            className: "custom-toast-success",
          });
          setStoreDetails(data?.data);
        } else if (data?.message.includes("try")) {
          setIsSyncModalOpen(false);
          // setIsChannelPartner(true);
          setIsSyncModalLoading(false);
          toast.success(data?.message, {
            className: "custom-toast-success",
          });
          setStoreDetails(data?.data);
        } else {
          dispatch(timerObject({ startTimer: true }));
          localStorage.setItem("isSyncCompleted", "false");
          setIsSyncModalLoading(true);
          toast.success(data?.message || "Sync In Progress", {
            className: "custom-toast-success",
          });
        }
      } else {
        return navigate("/catalogues/channel-integration");
      }
    } catch (error: any) {
      toast.error(error?.message || "Failed To Sync Channel");
      if (syncRef.current) {
        syncRef.current.childNodes[1].textContent = "Sync Channel";
        syncRef.current.style.backgroundColor = "white";
        syncRef.current.style.pointerEvents = "auto";
        syncRef.current.childNodes[0].classList.remove("infinite-rotate");
      }
    }
  };

  const warningMessageForDuplicate = (data: any) => {
    return (
      <div>
        <div>
          <span>
            Are You Sure You Want To Duplicate this Order - {data?.tempOrderId}
          </span>
        </div>
      </div>
    );
  };

  const warningMessageForDelete = (data?: any) => {
    const tempOrderIdArray = data?.tempOrderIdArray?.map(
      (tempOrderIdObj?: any) => tempOrderIdObj,
    );
    return (
      <div>
        <div>
          <span>
            {" "}
            Are You Sure You Want To Delete this
            {tempOrderIdArray?.length > 1 ? " Orders" : " Order"}
          </span>
          <div className="w-[450px] text-[16px]  truncate">
            {tempOrderIdArray?.join(", ")}
          </div>
        </div>
      </div>
    );
  };

  const warningMessageForCancel = (data?: any) => {
    return (
      <div>
        <div>
          <span>
            {" "}
            Are You Sure You Want To Cancel This
            {data > 1 ? " Orders" : " Order"}
          </span>
          <div className="w-[450px] text-[16px]  truncate">
            {data?.join(", ")}
          </div>
        </div>
      </div>
    );
  };

  const MobileButtons = (className?: string) => {
    return (
      <div
        className={
          className
            ? className
            : `flex items-center mx-5 mt-2 justify-between gap-6`
        }
      >
        <div
          className="flex flex-col items-center"
          onClick={() => navigate("/orders/place-order")}
        >
          <img src={AddOrderIcon} alt="" />
          <div className="text-[#004EFF] text-[12px]">ADD ORDER</div>
        </div>
        <div
          className="flex flex-col items-center "
          onClick={() => navigate("/orders/add-bulk")}
        >
          <img src={BlukOrderIcon} alt="" />
          <div className="text-[#004EFF] text-[12px]">BULK ORDER</div>
        </div>
      </div>
    );
  };

  const desktopSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
  };

  const mobileSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1, // Adjust the number of slides shown on mobile
    centerMode: true,
    slidesToScroll: 1,
    initialSlide: 0, // Start from the second slide to hide the slide on the left side
  };

  const currentSettings = isMobileView ? mobileSettings : desktopSettings;

  const getSingleFile = async (payload: any, actionType?: any) => {
    let awbs = {
      awbs: payload?.awbs,
      source: "WEBSITE",
    };
    const { sessionId, sellerInfo } = sessionManager({});
    const sellerId = sellerInfo?.sellerId;
    let header = {
      Accept: "/",
      // Authorization: `Bearer ${localStorage.getItem(
      //   `${sellerId}_${tokenKey}`
      // )}`,
      Authorization: `Bearer ${sellerInfo?.token}`,
      "Content-Type": "application/json",
    };

    if (actionType === "download_label") {
      try {
        const data = await fetch(FETCH_LABELS_REPORT_DOWNLOAD, {
          method: "POST",
          headers: header,
          body: JSON.stringify(awbs),
        });
        console.log(data);
        if (!data.ok) {
          const contentType = data.headers.get("Content-Type");

          if (contentType && contentType.includes("application/json")) {
            const jsonData = await data.json();
            console.log("JSON Data:", jsonData);

            if (!jsonData?.success) {
              toast.error(jsonData?.message);
            }
          } else {
            toast.error("An unexpected error occurred.");
          }

          return;
        }

        const resdata: any = await data?.blob();
        const blob = new Blob([resdata], { type: resdata?.type });
        let filename: any;
        if (resdata?.type === "image/png") {
          filename = "Label_Report.png";
        } else {
          filename = "Label_Report.pdf";
        }
        var url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        return true;
      } catch (error) {
        console.log(error);
      }
    } else {
      const data = await fetch(FETCH_MULTI_TAX_REPORT_DOWNLOAD, {
        method: "POST",
        headers: header,
        body: JSON.stringify(awbs),
      });

      const resdata: any = await data?.blob();

      const blob = new Blob([resdata], { type: "application/pdf" });

      var url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Tax_Report.pdf`;
      a.click();
      return true;
    }
  };

  const orderActions = (
    payLoad: any,
    actionType: any,
    currentStatus?: any,
    data?: any,
  ) => {
    switch (currentStatus) {
      case "DRAFT":
        if (actionType === "edit") {
          setPartnerModalData({
            isOpen: true,
            data: {
              tempOrderId: payLoad?.tempOrderIdArray?.[0],
              awb: "0",
            },
          });
        } else if (actionType === "duplicate_order") {
          setDuplicateOrderModalData({
            isOpen: true,
            data: {
              tempOrderId: data?.tempOrderId,
              payLoad: data,
            },
          });
        } else {
          setDeleteModalDraftOrder({
            isOpen: true,
            payload: payLoad,
            orderSources: data?.source ? [data.source] : [], // Add order source for single order deletion
          });
        }
        break;
      case "BOOKED":
      case "CANCELLED":
      case "PICKED UP":
      case "IN TRANSIT":
      case "OUT OF DELIVERY":
      case "DELIVERED":
      case "RETURN":
      case "RTO IN TRANSIT":
      case "RTO OUT FOR DELIVERY":
      case "RTO DELIVERED":
      case "RTO EXCEPTION":
      case "LOST_AND_DAMAGE":
        if (actionType === "cancel_order") {
          setCancellationModal({
            isOpen: true,
            payload: payLoad?.awbs,
            orderSources: data?.source ? [data.source] : [], // Add order source for single order cancellation
          });
        } else if (actionType === "download_label") {
          getSingleFile(payLoad, actionType);
        } else if (actionType === "download_invoice") {
          getSingleFile(payLoad, actionType);
        } else if (actionType === "create_reverse_order") {
          // Open the modal for creating a reverse order
          // setInfoModalContent({
          //   isOpen: true,
          //   data: data,
          //   orderId: data?.orderId,
          //   tempOrderId: data?.tempOrderId,
          //   isReverseOrder: true,
          // });

          navigate("/orders/place-order", {
            state: {
              isReverseOrder: true,
              awb: data?.awb,
              orderId: data?.orderId,
              tempOrderId: data?.tempOrderId,
              source: data?.source,
            },
          });
        } else if (actionType === "duplicate_order") {
          setDuplicateOrderModalData({
            isOpen: true,
            data: {
              tempOrderId: data?.tempOrderId,
              payLoad: data,
            },
          });
        }
        break;
      default:
        break;
    }
  };

  const setStatusCount = (
    statusListFromApi?: any[],
    currentStatus?: string,
    updatedCount: number | undefined = undefined,
    dateFilter = false,
  ) => {
    try {
      let tempArr = [...statusData];

      if (updatedCount === undefined && statusListFromApi?.length) {
        // Create a map for quick lookup
        const statusMap = new Map(
          statusListFromApi.map((item) => [
            item._id?.toUpperCase(),
            item?.count,
          ]),
        );

        tempArr = tempArr.map((element) => {
          const count =
            statusMap.get(element.value) ||
            (element.value === "LOST_AND_DAMAGE"
              ? statusMap.get("LOST/DAMAGE")
              : undefined);
          return {
            ...element,
            orderNumber: count
              ? count.toLocaleString("en-US", {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                })
              : dateFilter
                ? "00"
                : element.orderNumber, // Keep existing if dateFilter is false
          };
        });
      } else if (updatedCount !== undefined) {
        tempArr = tempArr.map((element) =>
          element.value === currentStatus
            ? {
                ...element,
                orderNumber: updatedCount.toLocaleString("en-US", {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                }),
              }
            : element,
        );
      }

      setStatusData(tempArr);
    } catch (error) {
      console.error("🚀 ~ setStatusCount error:", error);
    }
  };

  const handleTabChanges = async (
    index?: any,
    dateFilter = false,
    searchedText?: any,
    startDate?: any,
    endDate?: any,
    filterPayLoad?: any,
    itemsPerPage?: any,
  ) => {
    try {
      // const data = await getSellerOrderByStatus(
      //   statusData[index].value,
      //   1,
      //   { _id: -1 },
      //   0,
      //   itemsPerPage,
      //   dateFilter,
      //   searchedText,
      //   startDate,
      //   endDate,
      //   filterPayLoad
      // );
      // const { OrderData } = data;
      // setOrders(OrderData);
      // setAllOrders(OrderData);
      // setTotalOrders(OrderData);
      setGlobalIndex(index);

      setTabStatusId(index);

      let currentStatus = tabs[index].value;
      setCurrentTap(currentStatus);
      setIsErrorPage(index > 0 && false);
      index > 0 && setFilterId(0);

      switch (tabs[index].value) {
        case "DRAFT":
          setColumnhelper(
            columnHelperForNewOrder(
              navigate,
              setDeleteModalDraftOrder,
              setInfoModalContent,
              currentStatus,
              orderActions,
              setInfoModalContentFunction,
              buyerConfirmationStatus,
              setBuyerConfirmationStatus,
              isImpersonateLogin,
              setProductDetailsModal,
            ),
          );
          break;
        case "BOOKED":
          setColumnhelper(
            ColumnHelperForBookedAndReadyToPicked(
              navigate,
              setCancellationModal,
              setInfoModalContent,
              setInfoModalContentFunction,
              currentStatus,
              orderActions,
              setOpenRightModalForTracking,
              openRightModalForTracking,
              isMasked,
              buyerConfirmationStatus,
              setBuyerConfirmationStatus,
              isImpersonateLogin,
            ),
          );
          break;
        case "READYTOPICK":
          setColumnhelper(
            ColumnHelperForBookedAndReadyToPicked(
              navigate,
              setInfoModalContent,
              setInfoModalContentFunction,
              currentStatus,
              orderActions,
              setOpenRightModalForTracking,
              openRightModalForTracking,
              isMasked,
              buyerConfirmationStatus,
              setBuyerConfirmationStatus,
              isImpersonateLogin,
            ),
          );
          break;
        default:
          setColumnhelper(
            columnHelpersForRest(
              navigate,
              setInfoModalContent,
              currentStatus,
              orderActions,
              setInfoModalContentFunction,
              setInfoReverseModalFunction,
              setOpenRightModalForTracking,
              openRightModalForTracking,
              isMasked,
              buyerConfirmationStatus,
              setBuyerConfirmationStatus,
              isImpersonateLogin,
            ),
          );
          break;
      }
    } catch (error) {
      console.error("An error occurred in handleTabChanges function:", error);
    }
  };

  const PersistFilterArr = (key: any, data: any) => {
    setPersistFilterData((prevData: any) => {
      return { ...prevData, [key]: [...data] };
    });
  };

  function getObjectWithIsActiveTrue(data: any, name: any) {
    let tempArrTwo = filterPayLoad?.filterArrTwo;
    let tempArrOne = filterPayLoad?.filterArrOne;

    const updateFilterArr = (arr: any, key: any, subKey: any, data: any) => {
      console.log(arr, key, subKey, data, "ARR, KEY, SUBKEY, DATA");

      const index = arr.findIndex(
        (findArr: any) => Object.keys(findArr)[0] === key,
      );
      if (index > -1) {
        arr[index][key][subKey] = data;
      } else {
        const newObj = { [key]: { [subKey]: [...data] } };
        arr.push(newObj);
      }
    };

    switch (name) {
      case "Delivery Pincode":
        updateFilterArr(tempArrTwo, "deliveryAddress.pincode", "$in", data);
        PersistFilterArr("deliveryPincode", data);
        break;
      case "Pickup Pincode":
        updateFilterArr(tempArrTwo, "pickupAddress.pincode", "$in", data);
        PersistFilterArr("pickupPincode", data);
        break;
      case "Payment Type":
        const tempArr = [...data];

        for (let i = 0; i < tempArr?.length; i++) {
          if (tempArr[i] === "Prepaid") {
            tempArr[i] = false;
          } else if (tempArr[i] === "Cod") {
            tempArr[i] = true;
          }
        }

        updateFilterArr(tempArrOne, "codInfo.isCod", "$in", tempArr);
        PersistFilterArr("paymentType", data);
        break;
      case "Partners":
        updateFilterArr(tempArrOne, "service.partnerName", "$in", data);
        PersistFilterArr("partners", data);
        break;
      case "Order Type":
        updateFilterArr(tempArrOne, "orderType", "$in", data);
        PersistFilterArr("orderType", data);
        break;
      case "Sources":
        updateFilterArr(tempArrOne, "source", "$in", data);
        PersistFilterArr("sources", data);
        break;
      case "Seller Id":
        updateFilterArr(tempArrOne, "sellerId", "$in", data);
        PersistFilterArr("sellerId", data);
        break;
      case "Buyer Confirmation Status":
        updateFilterArr(tempArrOne, "isBuyerConfirmed", "$in", data);
        PersistFilterArr("buyerConfirmation", data);
        break;
      case "Store":
        updateFilterArr(tempArrOne, "otherDetails.storeId", "$in", data);
        PersistFilterArr("store", data);
        break;

      default:
        break;
    }

    tempArrOne = tempArrOne.filter((obj: any) => {
      const key = Object.keys(obj)[0];
      return obj[key].$in.length > 0;
    });

    tempArrTwo = tempArrTwo.filter((obj: any) => {
      const key = Object.keys(obj)[0];
      return obj[key].$in.length > 0;
    });

    setFilterPayLoad({
      ...filterPayLoad,
      filterArrTwo: [...tempArrTwo],
      filterArrOne: [...tempArrOne],
    });
  }

  const getStatusCount = async (payload: any) => {
    statusCountAbortRef.current?.abort();
    const controller = new AbortController();
    statusCountAbortRef.current = controller;
    const requestId = ++statusCountRequestIdRef.current;

    try {
      let currentStatus = tabs[globalIndex]?.value || "DRAFT";
      const response = await POST(GET_STATUS_COUNT, payload, {
        signal: controller.signal,
      });
      // allOrdersCount = data?.data?.[0]?.count;
      if (requestId !== statusCountRequestIdRef.current) return;

      const { status: isStatus, data: statusList } = response?.data || {};

      if (isStatus) {
        setStatusCount(statusList, currentStatus, undefined, true);
      }
    } catch (error) {
      console.error(
        "🚀 ~ file: index.tsx:609 ~ getStatusCount ~ error:",
        error,
      );
    }
  };

  const getIndexFromActiveTab = (arr: any, tabName: any) => {
    let tabIndex = arr.findIndex((e: any) => e.value === tabName);
    if (tabIndex > -1) {
      return +tabIndex;
    } else {
      return 0;
    }
  };

  const debounce = (fn: any, delay: any) => {
    let timerId: any;
    return (...args: any) => {
      clearTimeout(timerId);
      timerId = setTimeout(() => fn(...args), delay);
    };
  };

  const searchDebounce = useCallback(debounce(handleTabChanges, 1000), []);

  useEffect(() => {
    if (endDate === undefined) return;

    const tabIndex = activeTab
      ? getIndexFromActiveTab(statusData, activeTab)
      : 0;

    if (searchedText?.length > 0) {
      searchDebounce(
        tabIndex,
        true,
        searchedText,
        startDate,
        endDate,
        filterPayLoad,
        itemsPerPage,
      );
    } else {
      handleTabChanges(
        tabIndex,
        true,
        "",
        startDate,
        endDate,
        filterPayLoad,
        itemsPerPage,
      );
    }
  }, [endDate, activeTab, searchedText, buyerConfirmationStatus]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await POST(GET_COUNT_AMAZON_ORDER);
        if (data?.code === 200) {
          let temp = data?.data?.[0];

          setFullfillment(temp?.fullFillMent?.[0]?.fullFillMent || 0);
          setUnFullfillment(temp?.unfullFillCount?.[0]?.unfullFillCount || 0);
        }
      } catch (error) {
        toast.error("Something went wrong");
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await POST(GET_COUNT_SHOPIFY_FULFILLMENT);

        if (data?.code === 200) {
          let temp = data?.data;
          setShopifyFullfillment(temp?.fulfilled || 0);
          setUnShopifyFullfillment(temp?.booked || 0);
        }
      } catch (error) {
        toast.error("Something went wrong");
      }
    })();
  }, []);

  const onPageIndexChange = async (data: any) => {
    setSkip((data?.currentPage - 1) * data?.itemsPerPage);
  };

  const onPerPageItemChange = async (data: any) => {
    setItemsPerPage(data?.itemsPerPage);
    setSkip(0);
  };

  const getSellerOrder = async (
    currentStatus = "DRAFT",
    pageNo: number = 1,
    sort: object = { _id: -1 },
    skip: number = 0,
    limit: number = 100,
    dateFilter: any = false,
    searchText?: any,
    startDate?: any,
    endDate?: any,
    filterPayLoadData?: any,
  ) => {
    try {
      let payload: any;
      let dates: any = {};
      let allOrders: any;
      if (filterId === 1) {
        payload = {
          skip,
          limit,
          pageNo,
          sort,
          currentStatus,
          subStatus: "DRAFT",
        };
      } else {
        payload = {
          skip,
          limit,
          pageNo,
          sort,
          currentStatus,
        };
      }

      let firstFilterData = [];
      let secondFilterData = [];

      if (
        filterPayLoadData?.filterArrOne?.length > 0 ||
        filterPayLoadData?.filterArrTwo?.length > 0
      ) {
        const newFilterArrOne = filterPayLoadData?.filterArrOne.filter(
          (obj: any) => !Object.keys(obj).includes("createdAt"),
        );

        firstFilterData = newFilterArrOne;
        secondFilterData = filterPayLoadData?.filterArrTwo;
      }

      if (startDate && endDate) {
        let startEpoch = null;
        let lastendEpoch = null;

        if (startDate instanceof Date && endDate instanceof Date) {
          startDate.setHours(0, 0, 0, 0);
          startEpoch = startDate.getTime();

          endDate.setHours(23, 59, 59, 999);
          const endEpoch = endDate.getTime();

          lastendEpoch = endEpoch;
        }

        firstFilterData.unshift(
          {
            createdAt: {
              $gte: startEpoch,
            },
          },
          {
            createdAt: {
              $lte: lastendEpoch,
            },
          },
        );
      }

      if (firstFilterData?.length > 0 || secondFilterData?.length > 0) {
        payload.filterArrOne = firstFilterData;
        payload.filterArrTwo = secondFilterData;
      }

      if (startDate && endDate) {
        let startEpoch = null;
        let lastendEpoch = null;

        if (startDate instanceof Date && endDate instanceof Date) {
          startDate.setHours(0, 0, 0, 0);
          startEpoch = startDate.getTime();

          endDate.setHours(23, 59, 59, 999);
          const endEpoch = endDate.getTime();

          lastendEpoch = endEpoch;
        }

        dates.startDate = startEpoch;
        dates.endDate = lastendEpoch;
      }

      const { data: count } = await POST(GET_STATUS_COUNT, dates);
      allOrders = count?.data?.[0]?.count;

      // Lost and Damage tab sends LOST/DAMAGE to API
      const apiPayload = {
        ...payload,
        currentStatus:
          currentStatus === "LOST_AND_DAMAGE" ? "LOST/DAMAGE" : currentStatus,
      };
      let { data } = await POST(GET_SELLER_ORDER, apiPayload);

      const { orderCount } = data?.data[0];
      setTotalcount(orderCount ? orderCount : 0);

      setDraftOrderCount({ ...draftOrderCount, all: allOrders || orderCount });

      setSelectedRowData([]);

      if (data?.status) {
        return data?.data[0];
      } else {
        throw new Error(data?.meesage);
      }
    } catch (error: any) {
      toast.error(error);
      return false;
    }
  };

  const buildListDownloadPayload = () => {
    const currentStatus = tabs[globalIndex]?.value || "DRAFT";
    const { apiPayload } = buildOrderListApiPayload({
      skip,
      limit: itemsPerPage,
      filterPayLoad,
      startDate,
      endDate,
      searchedText,
      subStatus,
      currentStatus,
      sortByOrderId,
    });
    return apiPayload;
  };

  const fetchManifest = async (awbArray?: any, setIsLoadingManifest?: any) => {
    const selectAllContainer: any = document.getElementById("selectAll");
    const checkbox = selectAllContainer?.querySelector(
      'input[type="checkbox"]',
    );

    // Function to check if the checkbox is checked
    const isChecked = checkbox?.checked;
    let awbs: any = [];
    if (isChecked) {
      orders?.map((el: any, i: number) => {
        awbs.push(el?.awb);
      });
    } else {
      awbs.push(...awbArray.filter((item: any) => item !== ""));
    }
    let payload = {
      ...buildListDownloadPayload(),
      awbs,
      source: "WEBSITE",
    };
    setIsLoadingManifest({
      isLoading: true,
      identifier: "Download_menifest_report",
    });
    const { sellerInfo } = sessionManager({});
    const sellerId = sellerInfo?.sellerId;
    let header = {
      Accept: "/",
      // Authorization: `Bearer ${localStorage.getItem(
      //   `${sellerId}_${tokenKey}`
      // )}`,
      Authorization: `Bearer ${sellerInfo?.token}`,
      "Content-Type": "application/json",
    };
    const response = await fetch(FETCH_MANIFEST_DATA, {
      method: "POST",
      headers: header,
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const errorData = await response.json();
      toast.error(errorData.message);
      setIsLoadingManifest({
        isLoading: false,
        identifier: "",
      });
      return;
    }
    const data = await response.blob();

    const blob = new Blob([data], { type: "application/pdf" });

    var url = URL.createObjectURL(blob);
    setIsLoadingManifest({
      isLoading: false,
      identifier: "",
    });

    const a = document.createElement("a");
    a.href = url;
    a.download = `Manifest_Report.pdf`;
    a.click();
  };

  const fetchLabels = async (
    arrLebels: string[],
    setIsLoadingManifest: any,
  ) => {
    if (!arrLebels?.length) {
      toast.error("Please Select One Orders For label");
      return;
    }

    const selectAllContainer: any = document.getElementById("selectAll");
    const checkbox = selectAllContainer?.querySelector(
      'input[type="checkbox"]',
    );
    const isChecked = checkbox?.checked;

    let awbs: any = [];
    if (isChecked) {
      orders?.forEach((el: any) => {
        awbs.push(el?.awb);
      });
    } else {
      awbs.push(...arrLebels.filter((item: any) => item !== ""));
    }

    setIsLoadingManifest({
      isLoading: true,
      identifier: "Download_Labels",
    });

    const payload: any = {
      ...buildListDownloadPayload(),
      awbs,
      source: "WEBSITE",
    };

    const { sellerInfo } = sessionManager({});
    const sellerId = sellerInfo?.sellerId;
    const header = {
      Accept: "/",
      Authorization: `Bearer ${sellerInfo?.token}`,
      "Content-Type": "application/json",
    };

    try {
      const response = await fetch(FETCH_LABELS_REPORT_DOWNLOAD, {
        method: "POST",
        headers: header,
        body: JSON.stringify(payload),
      });

      setIsLoadingManifest({
        isLoading: false,
        identifier: "",
      });

      const contentType = response.headers.get("Content-Type");

      // 📦 Check if JSON response (image-based partners)
      if (contentType?.includes("application/json")) {
        const resJson = await response.json();

        const partnerName = resJson?.partnerName?.toUpperCase();
        const pngLinks: string[] = resJson?.imageUrls || [];
        console.log("png links", pngLinks);
        const isImageBasedPartner = [
          "MUTHOOT",
          "DELHIVERY",
          "BLUEDART",
          "XPRESSBEES",
          "GATI",
          "EKART",
        ].includes(partnerName);

        if (isImageBasedPartner && pngLinks.length > 0) {
          await downloadAllPngs(pngLinks);
          toast.success("PNG labels downloaded successfully!");
          return;
        } else {
          toast.error("No image labels found. 11");
          return;
        }
      }

      // 🧾 If it's not JSON, fallback to PDF blob
      const resBlob = await response.blob();
      const blob = new Blob([resBlob], { type: resBlob?.type });

      const filename =
        resBlob?.type === "image/png" ? "Label_Report.png" : "Label_Report.pdf";

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();

      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 1000);

      return true;
    } catch (error) {
      console.error("fetchLabels error:", error);
      toast.error("Something went wrong while fetching labels.");
      setIsLoadingManifest({
        isLoading: false,
        identifier: "",
      });
    }
  };

  const downloadAllPngs = async (pngLinks: string[], awb?: string) => {
    for (let i = 0; i < pngLinks.length; i++) {
      const url = pngLinks[i];

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Image fetch failed");

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = `${awb || "label"}_${i + 1}.png`;
        a.style.display = "none";

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);

        if (i < pngLinks.length - 1) {
          await new Promise((r) => setTimeout(r, 200));
        }
      } catch (err) {
        console.error(`Error downloading image ${i + 1}:`, err);
        window.open(url, "_blank");
      }
    }
  };

  const fetchMultiTax = async (
    arrLebels: string[],
    setIsLoadingManifest: any,
  ) => {
    if (!arrLebels?.length) {
      toast.error("Please Select One Orders For Tax Invoice");
      return;
    }

    const selectAllContainer: any = document.getElementById("selectAll");
    const checkbox = selectAllContainer?.querySelector(
      'input[type="checkbox"]',
    );

    // Function to check if the checkbox is checked
    const isChecked = checkbox?.checked;
    let awbs: any = [];
    if (isChecked) {
      orders?.map((el: any, i: number) => {
        awbs.push(el?.awb);
      });
    } else {
      awbs.push(...arrLebels.filter((item: any) => item !== ""));
    }

    setIsLoadingManifest({
      isLoading: true,
      identifier: "Download_Multi_Tax",
    });

    const payload: any = {
      ...buildListDownloadPayload(),
      awbs,
      source: "WEBSITE",
    };
    const { sellerInfo } = sessionManager({});
    const sellerId = sellerInfo?.sellerId;
    let header = {
      Accept: "/",
      // Authorization: `Bearer ${localStorage.getItem(
      //   `${sellerId}_${tokenKey}`
      // )}`,
      Authorization: `Bearer ${sellerInfo?.token}`,
      "Content-Type": "application/json",
    };
    const data = await fetch(FETCH_MULTI_TAX_REPORT_DOWNLOAD, {
      method: "POST",
      headers: header,
      body: JSON.stringify(payload),
    });

    setIsLoadingManifest({
      isLoading: false,
      identifier: "",
    });

    if (!data.ok) {
      const contentType = data.headers.get("Content-Type");

      // Check if the Content-Type indicates JSON
      if (contentType && contentType.includes("application/json")) {
        const jsonData = await data.json();
        console.log("JSON Data:", jsonData);

        if (!jsonData?.success) {
          toast.error(jsonData?.message);
        }
      } else {
        // Handle other types of responses or errors
        toast.error("An unexpected error occurred.");
      }

      return; // Exit the function to avoid further processing
    }

    const resdata: any = await data.blob();

    const blob = new Blob([resdata], { type: "application/pdf" });

    var url = URL.createObjectURL(blob);
    setIsLoadingManifest({
      isLoading: false,
      identifier: "",
    });

    const a = document.createElement("a");
    a.href = url;
    a.download = `Multi_Tax_Invoices.pdf`;
    a.click();
    return true;
  };

  if (isDeleted) {
    const newOrders = orders.filter(
      (elem: any) => elem?.status?.[0]?.AWB !== cancellationModal.awbNo,
    );
    setOrders(newOrders);
    setAllOrders(newOrders);
    setTotalOrders(newOrders);
    setIsDeleted(false);
  }

  const getErrors = async (isFetching?: any) => {
    try {
      let payload: any = {};
      let index: any = 0;
      let dateFilter: any = true;

      const newArray = filterPayLoad?.filterArrOne.filter(
        (obj) => !Object.keys(obj).includes("createdAt"),
      );

      if (newArray?.length > 0 || filterPayLoad?.filterArrTwo?.length > 0) {
        payload.filterArrOne = newArray || [];
        payload.filterArrTwo = filterPayLoad?.filterArrTwo || [];
      }

      if (startDate && endDate) {
        let startEpoch = null;
        let lastendEpoch = null;

        if (startDate instanceof Date && endDate instanceof Date) {
          startDate.setHours(0, 0, 0, 0);
          startEpoch = startDate.getTime();

          endDate.setHours(23, 59, 59, 999);
          const endEpoch = endDate.getTime();

          lastendEpoch = endEpoch;
        }

        payload.startDate = startEpoch;
        payload.endDate = lastendEpoch;
      }

      if (searchedText?.length > 0) {
        payload.id = searchedText;
      }

      setIsErrorListLoading(true);
      const { data } = await POST(GET_ORDER_ERRORS, payload);
      if (data?.status) {
        const result: any = [];
        let errorListCount = 0;

        for (const [key, value] of Object.entries(data?.data?.[0])) {
          const currentObject = {
            errorName: key,
            value: value,
          };
          result.push(currentObject);
        }

        result.forEach((item: any) => {
          if (item.value) {
            item.value.forEach((order: any) => {
              errorListCount += order.ordersCount || 0;
            });
          }
        });

        // if (isFetching) {
        //   const sellerOrder = await getSellerOrderByStatus(
        //     statusData[index].value,
        //     1,
        //     { _id: -1 },
        //     0,
        //     itemsPerPage,
        //     dateFilter,
        //     searchedText,
        //     startDate,
        //     endDate,
        //     filterPayLoad
        //   );

        //   setDraftOrderCount({
        //     ...draftOrderCount,
        //     all: sellerOrder.orderCount || 0,
        //     draft: sellerOrder.draftCount || 0,
        //     error: sellerOrder.errorCount || 0,
        //   });
        // }

        setErrorData(result);
        setTotalcount(0);
        setIsErrorListLoading(false);
      } else {
        setIsErrorListLoading(false);
      }
    } catch (error: any) {
      toast.error(error);
      return false;
    }
  };

  // useEffect(() => {
  //   (async () => {
  //     if (!infoModalContent.isOpen && currentTap == "DRAFT") {
  //       const data: any = await getSellerOrderByStatus(
  //         activeTab,
  //         1,
  //         { _id: -1 },
  //         0,
  //         itemsPerPage,
  //         true,
  //         searchedText,
  //         startDate,
  //         endDate,
  //         filterPayLoad
  //       );
  //       const { OrderData } = data;
  //       setOrders(OrderData);
  //     }
  //   })();
  // }, [infoModalContent]);

  useEffect(() => {
    getObjectWithIsActiveTrue(filterState?.menu, filterState?.name);
  }, [filterState]);

  useEffect(() => {
    if (!channelReduxData?.length) return;

    setIsSyncModalLoading(false);

    const isSyncComplete = channelReduxData.every(isChannelSyncComplete);

    if (isSyncComplete) {
      refreshOrdersAfterSync();
    }
  }, [channelReduxData]);

  useEffect(() => {
    const handleOrdersSyncComplete = () => {
      refreshOrdersAfterSyncRef.current();
    };

    window.addEventListener("orders-sync-complete", handleOrdersSyncComplete);

    return () => {
      window.removeEventListener(
        "orders-sync-complete",
        handleOrdersSyncComplete,
      );
    };
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const juspayOrderId = getLocalStorage("order_id");
        if (juspayOrderId) {
          const orderStatus = await POST(RECHARGE_STATUS, {
            orderId: juspayOrderId,
            paymentGateway: "JUSPAY",
            transactionId: juspayOrderId,
          });
          if (orderStatus?.data?.success === false) {
            toast.error("Something Went Wrong");
          } else {
            toast.success("Wallet Recharge Successfully");

            let paymentPayload: any = getLocalStorage("paymentErrorObject");
            if (paymentPayload) {
              paymentPayload = JSON.parse(paymentPayload);
              await POST(PAYMENT_ERRORS, paymentPayload);
            }
            removeLocalStorage("paymentErrorObject");
          }
          removeLocalStorage("order_id");
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  useEffect(() => {
    if (syncRef.current && (syncTimerState || syncTimerState <= 0)) {
      syncRef.current.style.pointerEvents = "none";
      syncRef.current.style.backgroundColor = "#A4A4A4";
      syncRef.current.childNodes[2].style.width = `${
        100 - (100 * syncTimerState) / 180
      }%`;
      if (!syncTimerState || syncTimerState == "0") {
        syncRef.current.classList.add("zoom-in");
        syncRef.current.style.pointerEvents = "all";

        const isSyncCompleted = localStorage.getItem("isSyncCompleted");
        if (isSyncCompleted === "true") {
          refreshOrdersAfterSync();
        }
      }
    }
  }, [syncTimerState]);

  return (
    <>
      {isActive ? (
        <div>
          <Breadcrum label="Orders" component={Buttons()} />

          {/* MobileButtons removed: desktop actions are now responsive */}

          <div className="mt-3 sm:mt-4 px-4 md:pl-5 md:pr-6">
            <div className="bg-white">
              <OrderStatus
                filterId={filterId}
                itemPerPage={itemsPerPage}
                skip={skip}
                orders={orders}
                setSubStatus={setSubStatus}
                setIsOrderPlaced={setIsOrderPlaced}
                setFilterId={setFilterId}
                handleTabChange={handleTabChanges}
                statusData={statusData}
                setOrders={setOrders}
                allOrders={allOrders}
                currentStatus={tabs[globalIndex].value}
                selectedRowdata={selectedRowdata}
                setSelectedRowData={setSelectedRowData}
                fetchLabels={fetchLabels}
                fetchManifest={fetchManifest}
                fetchMultiTax={fetchMultiTax}
                setDeleteModalDraftOrder={setDeleteModalDraftOrder}
                setCancellationModal={setCancellationModal}
                tabStatusId={tabStatusId}
                setTotalcount={setTotalcount}
                draftOrderCount={draftOrderCount}
                setStatusCount={setStatusCount}
                isOrderTableLoader={setIsLoading}
                totalOrders={totalOrders}
                setDraftOrderCount={setDraftOrderCount}
                setIsErrorPage={setIsErrorPage}
                setErrorData={setErrorData}
                setIsErrorListLoading={setIsErrorListLoading}
                getErrors={getErrors}
                selectedDateRange={{ startDate, endDate }}
                filterPayLoad={filterPayLoad}
                isLoading={isLoading}
                bulkActionObject={bulkActionObject}
                setBulkActionObject={setBulkActionObject}
                setIsBulkCheckedBooked={setIsBulkCheckedBooked}
                isBulkCheckedBooked={isBulkCheckedBooked}
                totalCount={totalCount}
                getAllOrders={getAllOrders}
                orderListSearchQuery={searchedText}
                subStatus={subStatus}
                sortByOrderId={sortByOrderId}
              />
            </div>
            <div ref={scrollRef} className="my-0 h-[calc(100%-180px)]">
              {isLoading ? (
                <>
                  {isLgScreen ? (
                    <div>
                      <div className="flex items-stretch h-16 rounded-xl">
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                      </div>
                      <div className="flex items-stretch h-44 rounded-xl">
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                      </div>
                      <div className="flex items-stretch h-44 rounded-xl">
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                        <div className="flex-1 m-2 animated rounded-xl"></div>
                      </div>
                    </div>
                  ) : (
                    <div className="mt-4">
                      <div className="flex items-stretch h-44 rounded-xl">
                        <div className="flex-1 my-2 animated rounded-xl"></div>
                      </div>
                      <div className="flex items-stretch h-44 rounded-xl">
                        <div className="flex-1 my-2 animated rounded-xl"></div>
                      </div>
                      <div className="flex items-stretch h-44 rounded-xl">
                        <div className="flex-1 my-2 animated rounded-xl"></div>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div>
                  {
                    isErrorPage ? (
                      <div className="mt-5">
                        <Errors
                          errorData={errorData}
                          setIsErrorModalOpen={setIsErrorModalOpen}
                          isErrorModalOpen={isErrorModalOpen}
                          setErrorModalData={setErrorModalData}
                          isLoading={isErrorListLoading}
                          getErrors={getErrors}
                        />
                      </div>
                    ) : (
                      <>
                        {isLgScreen ? (
                          <CustomTable
                            rowData={orders || []}
                            columnsData={columnHelper || []}
                            setRowSelectedData={setSelectedRowData}
                          />
                        ) : (
                          <div className="border border-white my-5">
                            {orders?.length > 0 ? (
                              <div className="flex flex-col gap-3">
                                {orders?.map((data: any, i: any) => (
                                  <OrderCard
                                    key={`${data?.tempOrderId || data?.orderId || data?.awb || i}`}
                                    data={data}
                                    currentStatus={tabs[tabStatusId].value}
                                    orderActions={orderActions}
                                    setInfoModalContentFunction={
                                      setInfoModalContentFunction
                                    }
                                  />
                                ))}
                              </div>
                            ) : (
                              <div className="w-full h-52 bg-[#f7f7f7] hover:bg-[#e9e9e9] flex rounded-lg justify-center items-center">
                                No Data Found
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    )
                    // : (
                    //   <div className="border border-white my-5">
                    //     {/* {orders?.length > 0 ? (
                    //       <>
                    //         {orders?.map((data: any, i: any) => (
                    //           <OrderCard
                    //             data={data}
                    //             currentStatus={tabs[tabStatusId].value}
                    //             orderActions={orderActions}
                    //           />
                    //         ))}
                    //       </>
                    //     ) : (
                    //       <div className="w-[100%] h-52 bg-[#f7f7f7] hover:bg-[#e9e9e9] flex rounded-lg justify-center items-center">
                    //         No Data Found
                    //       </div>
                    //     )} */}
                    //   </div>
                    // )
                  }
                </div>
              )}
            </div>
            <div className="mt-6 mb-6">
              {totalCount > 0 && (
                <OnePagination
                  totalItems={totalCount}
                  itemsPerPageOptions={[
                    10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000,
                  ]}
                  onPageChange={onPageIndexChange}
                  onItemsPerPageChange={onPerPageItemChange}
                  initialItemsPerPage={itemsPerPage}
                  pageNo={Math.floor(skip / itemsPerPage) + 1}
                  className="pb-6"
                />
              )}
            </div>
          </div>
        </div>
      ) : (
        <AccessDenied />
      )}
      <DeleteModal
        isOpen={cancellationModal?.isOpen}
        setModalClose={() =>
          setCancellationModal({
            ...cancellationModal,
            isOpen: false,
          })
        }
        deleteTextMessage={warningMessageForCancel(cancellationModal?.payload)}
        payloadBody={cancellationModal.payload}
        orderSources={cancellationModal.orderSources} // Add this line
        deleteURL={CANCEL_MULTIPLE_WAYBILLS}
        setIsDeleted={setIsDeleted}
        reloadData={handleTabChanges}
      />

      <DeleteModalDraftOrder
        url={CANCEL_TEMP_SELLER_ORDER}
        postData={deleteModalDraftOrder?.payload}
        isOpen={deleteModalDraftOrder?.isOpen}
        reloadData={handleTabChanges}
        orderSources={deleteModalDraftOrder?.orderSources} // Add this line
        closeModal={() => {
          setDeleteModalDraftOrder({
            ...deleteModalDraftOrder,
            isOpen: false,
          });
        }}
        title={warningMessageForDelete(deleteModalDraftOrder?.payload)}
      />

      <DuplicateModel
        url={DUPLICATE_ORDER}
        postData={duplicateOrderModalData?.data?.payLoad}
        isOpen={duplicateOrderModalData?.isOpen}
        reloadData={handleTabChanges}
        closeModal={() => {
          setDuplicateOrderModalData({
            ...duplicateOrderModalData,
            isOpen: false,
          });
        }}
        title={warningMessageForDuplicate(duplicateOrderModalData?.data)}
      />
      <CustomRightModal
        isOpen={infoModalContent.isOpen}
        onClose={() => setInfoModalContent({ isOpen: false, data: {} })}
        className="!justify-start !w-[400px] xl:!w-[650px]"
        showMobileCancelButton={false}
      >
        <div className="sticky top-0 z-10 bg-white border-b border-gray-200">
          <div className="flex items-center justify-between gap-2 px-4 py-3">
            <div className="text-[16px] font-semibold text-[#1C1C1C] whitespace-nowrap">
              Order Details
            </div>
            <button
              type="button"
              onClick={() => setInfoModalContent({ isOpen: false, data: {} })}
              className="h-9 w-9 flex items-center justify-center rounded-full hover:bg-gray-100 active:bg-gray-200"
              aria-label="Close"
            >
              <img src={CloseIcon} alt="" className="h-4 w-4 opacity-80" />
            </button>
          </div>
        </div>
        <div className="flex justify-between mt-[1rem] rounded-lg mx-[1rem] h-[3rem] items-center bg-[#E5EDFF] border-b-2 w-[95%] px-[1rem] text-[16px]  py-8 ">
          <div className="">
            {infoModalContent?.data?.orderNumber && (
              <p>
                <span>Order Number:</span>
                {infoModalContent?.data?.orderNumber || ""}{" "}
              </p>
            )}
            <hr />
            <p className="mt-1">
              <span>{capitalizeFirstLetter(companyName)} ID:</span>
              {/* {infoModalContent?.data?.orderId?.split("T")?.[1] ||
                infoModalContent?.data?.orderId ||
                ""} */}
              {infoModalContent?.data?.tempOrderId || ""}
            </p>
          </div>
        </div>
        <div className="overflow-y-auto max-h-[80vh]">
          <CustomTableAccordian
            getAllSellerData={infoModalContent}
            isMasked={isMasked}
            currentStatus={tabs[globalIndex].value}
            isImpersonateLogin={isImpersonateLogin}
            onClose={() => setInfoModalContent({ isOpen: false, data: {} })}
            onOrderPlaced={() => {
              setInfoModalContent({ isOpen: false, data: {} });
              getAllOrders().catch((error) =>
                console.error("Failed to refresh orders:", error),
              );
            }}
          />
        </div>
      </CustomRightModal>

      {productDetailsModal.isOpen && (
        <div
          className="fixed inset-0 z-20 flex items-center justify-center bg-gray-800 bg-opacity-50"
          role="presentation"
          onMouseDown={() =>
            setProductDetailsModal({ isOpen: false, data: {} })
          }
        >
          <div
            role="dialog"
            aria-modal="true"
            aria-label="Draft order product details"
            className="customScroll flex max-h-[90vh] w-[calc(100%-32px)] max-w-[960px] flex-col overflow-hidden rounded-lg bg-white outline-none"
            onMouseDown={(event) => event.stopPropagation()}
          >
            <DraftOrderProductModal
              isOpen={productDetailsModal.isOpen}
              order={productDetailsModal.data}
              onClose={() =>
                setProductDetailsModal({ isOpen: false, data: {} })
              }
            />
          </div>
        </div>
      )}

      {/* Reverse Order Modal */}
      <CustomRightModal
        isOpen={infoReverseModalContent.isOpen}
        onClose={() => setInfoReverseModalContent({ isOpen: false, data: {} })}
        className="!justify-start !w-[434px]"
      >
        <div>
          <div className="p-[20px] flex justify-between">
            <div className="flex">
              <img src={Delivery_Icon} className="mr-2" />
              <span className="text-[24px] font-Lato font-normal">
                Reverse Order
              </span>
            </div>
            <div
              className="cursor-pointer"
              onClick={() =>
                setInfoReverseModalContent({ isOpen: false, data: {} })
              }
            >
              <img src={CloseIcon} />
            </div>
          </div>
        </div>
        <ReverseCustomAccordian
          awbData={infoReverseModalContent}
          summaryData={setInfoReverseSummaryModalFunction}
        />
      </CustomRightModal>

      {/* Reverse Order Summary Modal */}
      <CustomRightModal
        isOpen={infoReverseSummaryModalContent.isOpen}
        onClose={() =>
          setInfoReverseSummaryModalContent({ isOpen: false, data: {} })
        }
        className="!justify-start !w-[434px]"
      >
        <div>
          <div className="p-[20px] flex justify-between">
            <div className="flex">
              <img src={Delivery_Icon} className="mr-2" />
              <span className="text-[24px] font-Lato font-normal">
                Reverse Order
              </span>
            </div>
            <div
              className="cursor-pointer"
              onClick={() =>
                setInfoReverseSummaryModalContent({ isOpen: false, data: {} })
              }
            >
              <img src={CloseIcon} />
            </div>
          </div>
        </div>
        <ReverseSummary
          summaryData={infoReverseSummaryModalContent?.data}
          setState={setInfoReverseSummaryModalContent}
          reverseModal={setInfoReverseModalContent}
          bookOrder={setBookReverseCenterModal}
        />
      </CustomRightModal>

      {/* center modal for book reverse order */}
      <CenterModal
        isOpen={bookReverseCenterModal}
        onRequestClose={() => setBookReverseCenterModal(false)}
        className="max-w-[500px] max-h-[300px]"
      >
        <div className="flex flex-col text-center text-[18px] text-[#1C1C1C] font-Lato font-normal">
          <img src={DoneIcon} className="h-[124px] w-[124px] self-center" />
          <span>Thank You</span>
          <span>Your Reverse order has been placed.</span>
          <span>You can find your orders in Reverse section</span>
          <CustomButton
            className="mt-[24px] w-[127px] h-[20px] p-4 self-center"
            text={"GO TO ORDER"}
            onClick={() => setBookReverseCenterModal(false)}
          />
        </div>
      </CenterModal>

      <CustomRightModal
        isOpen={isErrorModalOpen}
        onClose={() => setIsErrorModalOpen(false)}
        className="!justify-start "
      >
        <ErrorModal
          errorModalData={errorModalData}
          setIsErrorModalOpen={setIsErrorModalOpen}
        />
      </CustomRightModal>

      <CustomRightModal
        isOpen={partnerModalData.isOpen}
        onClose={() => setPartnerModalData({ isOpen: false })}
        className="!justify-start"
      >
        <PartnerJumperModal
          partnerModalData={partnerModalData}
          closeModal={() => setPartnerModalData({ isOpen: false })}
        />
      </CustomRightModal>
      <CustomRightModal
        isOpen={filterModal}
        onClose={() => setFilterModal(false)}
        className="!justify-start"
      >
        <div className="h-full min-h-0 flex flex-col overflow-hidden">
          <div className="flex-shrink-0 flex justify-between items-center gap-3 px-5 py-4 border-b border-gray-200 bg-white">
            <p className="text-lg sm:text-xl font-semibold text-[#1C1C1C]">
              Filter
            </p>
            <button
              type="button"
              onClick={() => setFilterModal(false)}
              className="text-gray-600 hover:text-gray-800 text-2xl leading-none flex-shrink-0"
              aria-label="Close filter"
            >
              ×
            </button>
          </div>

          <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden px-5 py-4 bg-gray-50">
            <FilterScreen
              filterState={filterState}
              setFilterState={setFilterState}
              setFilterPayLoad={setFilterPayLoad}
              filterPayLoad={filterPayLoad}
              filterModal={filterModal}
              setPersistFilterData={setPersistFilterData}
              persistFilterData={persistFilterData}
              sortByOrderId={sortByOrderId}
              setSortByOrderId={setSortByOrderId}
              currentStatus={
                tabs[globalIndex]?.value === "LOST_AND_DAMAGE"
                  ? "LOST/DAMAGE"
                  : tabs[globalIndex]?.value || "DRAFT"
              }
            />
          </div>

          <div className="flex-shrink-0 border-t border-gray-200 bg-white p-4 flex gap-3">
            <OneButton
              text="RESET ALL"
              onClick={() => resetAllFilter()}
              className="w-full !rounded-full !px-4 !py-2 !text-sm"
              variant="secondary"
            />
            {isFilterLoading ? (
              <div className="w-full flex justify-center items-center">
                <Spinner />
              </div>
            ) : (
              <OneButton
                text="APPLY"
                onClick={() => {
                  getAllOrders();
                  setFilterModal(false);
                  setResetFilter(false);
                }}
                className="w-full !rounded-full !px-4 !py-2 !text-sm"
                variant="primary"
              />
            )}
          </div>
        </div>
      </CustomRightModal>

      <CustomRightModal
        isOpen={isSyncModalOpen}
        onClose={() => setIsSyncModalOpen(false)}
        className="!justify-start"
      >
        <div className="mt-[2rem]">
          {isSyncModalLoading ? (
            <div className="flex justify-center h-[90vh] items-center lg:!py-2 lg:!px-4">
              <Spinner />
            </div>
          ) : isChannelPartner ? (
            <div>
              <div className="mt-[1rem] mx-[1rem] flex flex-col  p-[1rem] border-4 rounded-md">
                <div>
                  Due to Unicommerce integration, cart syncing will be disabled
                  for our web application.. <br />
                  To Enable Sync Please Contact Administration.
                </div>
                {/* <div className="mt-[2rem] border-4 px-[0.5rem] py-[0.25rem] w-[max-content] rounded-md">
                    Go To Catalogue
                  </div> */}
              </div>

              {storeDetails?.map((store: any) => (
                <div className="w-[100%] flex justify-center">
                  <div className="mt-[1rem] mx-[1rem] flex p-[1rem] border-4 rounded-md w-[100%]">
                    <div className="min-w-[45%]">
                      <img
                        src={`${
                          store.channel === "SHOPIFY"
                            ? ShopifyIcon
                            : store.channel === "WOOCOMMERCE"
                              ? WoocommerceIcon
                              : store.channel === "UNICOMMERCE"
                                ? UnicommerceIcon
                                : "/"
                        }`}
                        alt="store icon"
                        width={150}
                      />
                    </div>
                    <div>
                      <div>
                        Store Name: {capitalizeFirstLetter(store.storeName)}
                      </div>
                      <div className="flex items-center gap-x-2">
                        {/* <span>Sync</span> */}
                        {/* <CustomSwitchToggle
                          toggleValue={(boolean: boolean) =>
                            console.log(boolean)
                          }
                          initValue={false}
                        /> */}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            channelReduxData.map((elem: any) => (
              <div className="mt-[1rem] mx-[1rem] p-[1rem] items-center flex flex-col border-4 rounded-md">
                <div className="my-[2rem] text-[18px] w-full flex flex-wrap items-center ">
                  <div className="w-[85%] flex gap-x-1">
                    <div>
                      <b>{`${capitalizeFirstLetter(elem?.channel)}`} </b>
                    </div>
                    <div>-</div>
                    <div
                      className="w-[55%]"
                      style={{
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: "1",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {elem.storeName}
                    </div>
                  </div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div>
                <div className="w-full mb-[1rem]">
                  <div className="progress-bar overflow-hidden">
                    <div
                      className="h-full bg-[#06981d] transition-all duration-700 ease-in-out rounded-sm"
                      style={{
                        width: `${
                          elem?.TotalOrderCount
                            ? (elem?.syncedOrder / elem?.TotalOrderCount) * 100
                            : 0
                        }%`,
                      }}
                    ></div>
                  </div>
                  <div className="flex justify-between mt-1 text-sm text-[#1C1C1C]">
                    <span>{elem?.syncedOrder || 0}</span>
                    <span>{elem?.TotalOrderCount || 0}</span>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </CustomRightModal>

      {/* new Tracking Screen with right modal  */}
      <CustomRightModal
        isOpen={openRightModalForTracking?.isOpen}
        onClose={() =>
          setOpenRightModalForTracking({
            ...openRightModalForTracking,
            isOpen: false,
          })
        }
        className=""
      >
        <NewTrackingContent
          setOpenRightModalForTracking={setOpenRightModalForTracking}
          openRightModalForTracking={openRightModalForTracking}
        />
      </CustomRightModal>

      {/* delta on blaze right modal  */}
      <CustomRightModal
        isOpen={openRightModalForDelta}
        onClose={() => setOpenRightModalForDelta(false)}
        className={`${isXlScreen ? "!w-1/2" : isLgScreen ? "!w-2/3" : ""}`}
      >
        <>
          <DeltaOnBlaze setOpenRightModalForDelta={setOpenRightModalForDelta} />
        </>
      </CustomRightModal>
    </>
  );
};

export default Index;
